import { theme } from '../../../../electrons';
export function useCodePatternService({ codePattern, onCodePatternChange, }) {
    const handleButtonVariant = (buttonIndex) => buttonIndex === codePattern ? 'contained' : 'outlined';
    const handleButtonColor = (buttonIndex) => buttonIndex === codePattern ? 'primary' : 'secondary';
    const handleIconColor = (buttonIndex) => buttonIndex === codePattern
        ? theme.colors.primary.contrastWhite
        : theme.colors.text[900];
    const handleOnClick = (buttonIndex) => {
        onCodePatternChange(buttonIndex);
    };
    return {
        handleButtonVariant,
        handleButtonColor,
        handleIconColor,
        handleOnClick,
    };
}
//# sourceMappingURL=useCodePatternService.js.map